import React, { useState, useEffect, useRef, useCallback } from "react";
import "../../css/Acquisition.css";
import 'font-awesome/css/font-awesome.min.css';
import '@fontsource/poppins';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import chandigharSvg from "../../images/Acquisition/chandigarh.svg";
import amritsarSvg from "../../images/Acquisition/amritsar.svg";
import delhiSvg from "../../images/Acquisition/delhi.svg";
import mumbaiSvg from "../../images/Acquisition/mumbai.svg";
import kanpurSvg from "../../images/Acquisition/kanpur.svg";
import bangaluruSvg from "../../images/Acquisition/bangaluru.svg";
import ahmedabadSvg from "../../images/Acquisition/ahmedabad.svg";
import chennaiSvg from "../../images/Acquisition/chennai.svg";
import hyderabadSvg from "../../images/Acquisition/hyderabad.svg";
import kolkataSvg from "../../images/Acquisition/kolkata.svg";
import cityDefaultSvg from "../../images/Acquisition/city_default_img.svg";
import hindustan_times_mint from "../../images/Acquisition/hindustan_times_mint.png";
import hindustan_times_hh from "../../images/Acquisition/hindustan_times_hh.png";
import hindustan_times from "../../images/Acquisition/hindustan_times.svg";
import livemint from "../../images/Acquisition/livemint.svg";
import onlylivemint from "../../images/onlylivemint.png";
import mint_livemint from "../../images/mint-livemint.png";
import hindustan from "../../images/Acquisition/hundustan.png";
import bellIcon from "../../images/Acquisition/bell-icon.svg";
import giftIcon from "../../images/Acquisition/gift-icon.svg";
import telephoneIcon from "../../images/FAQ/telephone_icon.svg";
import mailIcon from "../../images/FAQ/mail_icon.svg";
import contectUsIcon from "../../images/FAQ/contect-us-icon.svg";
import UserService from "../../services/UserService";
import { getUtmSource, registrationGetCityName,  GTM_data_push, getUtmUrl } from "../../common/commonFuntion";
import AuthService from "../../services/AuthService";
import ReactGA from "react-ga4";
import AllSchemes from "../../components/AllSchemes";
import Order from "../../components/Acquisition/Order";
import LoginSidebar from "../../subComponents/LoginSidebar";
import PageLoader from "../../subComponents/PageLoader";
import GiftSelectionModal from "../../subComponents/GiftSelectionModal";
import PopupContactus from "../../subComponents/PopupContactus";
import Footer from '../../components/Footer';
import {planNames} from '../../utils/utils.js';
import { ToastContainer, toast } from 'react-toastify';

const CORPORATE_STATUS = process.env.REACT_APP_CORPORATE_STATUS === 'true';

const cityImagesArr = {
  delhi: delhiSvg,
  mumbai: mumbaiSvg,
  kanpur: kanpurSvg,
  amritsar: amritsarSvg,
  cpm: chandigharSvg,
  bangalore: bangaluruSvg,
  kolkata: kolkataSvg,
  chennai: chennaiSvg,
  hyderabad: hyderabadSvg,
  ahmedabad: ahmedabadSvg,
};

const publicationImg = { 
  'HT': hindustan_times, 
  'Mint': livemint, 
  'BP': livemint, 
  'HT;Mint': hindustan_times_mint, 
  'HT;HH': hindustan_times_hh, 
  'HH': hindustan, 
  'Mint;LM': mint_livemint, 
  'LM;Mint': mint_livemint, 
  'LM': onlylivemint 
};

// Helper functions
const sortCitybyOrder = (a, b) => {
  const cityNameOrder = [
    "delhi",
    "mumbai",
    "kanpur",
    "amritsar",
    "cpm",
    "bangalore",
    "kolkata",
    "chennai",
    "hyderabad",
    "ahmedabad",
  ];
  return (
    cityNameOrder.indexOf(a.name.toLowerCase()) -
    cityNameOrder.indexOf(b.name.toLowerCase())
  );
};

// Add this helper function after the existing helper functions
const sortSchemesByPublication = (schemes) => {
  const publicationOrder = ['HT', 'HT;HH', 'Mint', 'HT;Mint'];
  
  return schemes.sort((a, b) => {
    const aIndex = publicationOrder.indexOf(a.publications);
    const bIndex = publicationOrder.indexOf(b.publications);
    
    // If both publications are in the order array, sort by their index
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }
    
    // If only 'a' is in the order array, it comes first
    if (aIndex !== -1 && bIndex === -1) {
      return -1;
    }
    
    // If only 'b' is in the order array, it comes first
    if (aIndex === -1 && bIndex !== -1) {
      return 1;
    }
    
    // If neither is in the order array, maintain existing order
    return 0;
  });
};

const filterSchemes = (data) => {
  const result = [];
  for (const schemes of Object.values(data)) {
    const groupedByYear = schemes.reduce((acc, scheme) => {
      const { duration, price } = scheme;
      acc[duration] = acc[duration] || [];
      acc[duration].push(scheme);
      return acc;
    }, {});
    
    for (const schemes of Object.values(groupedByYear)) {
      if (schemes.length === 1) {
        result.push(schemes[0]);
      } else {
        const leastPriceScheme = schemes.reduce((min, scheme) =>
          scheme.price < min.price ? scheme : min
        );
        result.push(leastPriceScheme);
      }
    }
  }
  
  // Sort the result by publication order
  return sortSchemesByPublication(result);
};

// Add helper function to find region with most data
const findRegionWithMostData = (regions) => {
  if (!regions || regions.length === 0) return null;
  
  let bestRegion = null;
  let maxSchemes = 0;
  
  regions.forEach(region => {
    if (region.regional_publication_wise_schemes) {
      const schemeCount = Object.values(region.regional_publication_wise_schemes)
        .flat()
        .length;
      
      if (schemeCount > maxSchemes) {
        maxSchemes = schemeCount;
        bestRegion = region;
      }
    }
  });
  
  // If no region has data, return the first region as fallback
  return bestRegion || regions[0];
};

const AcqHomepage = () => {
  // Refs
  const pincodeInputRef = useRef(null);
  
  // State variables
  const [pageLoader, setPageLoader] = useState(true);
  const [cityList, setCityList] = useState([]);
  const [allGifts, setAllGifts] = useState([]);
  const [selectedCityIndex, setSelectedCityIndex] = useState(0);
  const [showPincodeBar, setShowPincodeBar] = useState(false);
  const [showRegions, setShowRegions] = useState(true);
  const [showProeedBtn, setShowProeedBtn] = useState(true);
  const [showAcquisitionModel, setShowAcquisitionModel] = useState(true);
  const [showLoginModel, setShowLoginModel] = useState(false);
  const [showCheckoutModel, setShowCheckoutModel] = useState(false);
  const [isCheckedWhatsappBox, setIsCheckedWhatsappBox] = useState(true);
  const [pincodeValue, setPincodeValue] = useState("");
  const [showPincodeServiceAbleIssue, setShowPincodeServiceAbleIssue] = useState(false);
  const [pincodeValueErrorMsg, setPincodeValueErrorMsg] = useState(false);
  const [cityPublicationScheme, setCityPublicationScheme] = useState([]);
  const [publicationCheckedStatus, setPublicationCheckedStatus] = useState("");
  const [seeLessCityView, setSeeLessCityView] = useState(true);
  const [seeMoreCityView, setSeeMoreCityView] = useState(false);
  const [showPopupAlertState, setShowPopupAlertState] = useState(false);
  const [forInstitutional, setForInstitutional] = useState(false);
  const [showGiftSelectionModal, setShowGiftSelectionModal] = useState(false);
  const [showPublicationImage, setShowPublicationImage] = useState(null);
  const [selectedGiftOne, setSelectedGiftOne] = useState(null);
  const [showAcquisitionHeader, setShowAcquisitionHeader] = useState(true);
  const [regionList, setRegionList] = useState([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [orderData, setOrderData] = useState({
    planId: "",
    planName: "",
    planPrice: "",
    coverPrice: "",
    planDuration: "",
    cityName: "",
    cityPincode: "",
    gift_id: "",
  });
  
  // Toast notification
  const errorMsg = useCallback((errorMsg) => toast.warn(errorMsg, {
    position: "top-center"
  }), []);

  // Redirect handler
  const redirectToHome = useCallback(() => {
    const utmUrl = getUtmUrl('msg');
    window.location.href = forInstitutional ? window.location.origin : utmUrl;
  }, [forInstitutional]);

  // Pincode input handler
  const handleInputValue = useCallback((e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setPincodeValue(e.target.value);
      if (e.target.value.length > 5) {
        setShowPincodeServiceAbleIssue(false);
        setPincodeValueErrorMsg(false);
      }
    }
  }, []);

  // WhatsApp checkbox handler
  const handleWhatsappChange = useCallback(() => {
    const newValue = !isCheckedWhatsappBox;
    setIsCheckedWhatsappBox(newValue);
    sessionStorage.setItem("stg_isWhatsappChecked", newValue);
  }, [isCheckedWhatsappBox]);

  // City change handler
  const cityChange = useCallback((e) => {
    const index = e.target.value;
    setSelectedGiftOne(null);
    if (index === "-1") {
      setShowPincodeBar(false);
      setShowProeedBtn(false);
      setShowPincodeServiceAbleIssue(false);
      setShowRegions(false);
      setSelectedRegionId(null);
    } else {
      const city = cityList[index];
      
      // 🔹 RESET selectedRegionId when changing cities
      setSelectedRegionId(null);
      
      // Get city publication schemes (sales org level)
      const cityPublicationObj = filterSchemes(
        Object.values(city.publication_wise_schemes).reverse()
      );
      
      let finalSchemes = [...cityPublicationObj];
      let targetRegion = null;
      
      if (city?.regions?.length > 0) {
        // Find the region with most data for the NEW city
        targetRegion = findRegionWithMostData(city.regions);
        
        if (targetRegion && targetRegion.regional_publication_wise_schemes) {
          const regionalSchemes = filterSchemes(
            Object.values(targetRegion.regional_publication_wise_schemes).reverse()
          );
          
          // Get regional scheme keys for current region only
          const regionalSchemeKeys = regionalSchemes.map(scheme => 
            `${scheme.publications}_${scheme.duration}`
          );
          
          // Filter out sales org schemes that exist in current region
          const filteredSalesOrgSchemes = cityPublicationObj.filter(scheme => 
            !regionalSchemeKeys.includes(`${scheme.publications}_${scheme.duration}`)
          );
          
          // Combine filtered sales org schemes with regional schemes
          finalSchemes = [...filteredSalesOrgSchemes, ...regionalSchemes];
        }
        
        // Set the new region with most data as selected
        setSelectedRegionId(targetRegion.id);
        setRegionList(city.regions);
        setShowRegions(true);
      } else {
        setShowRegions(false);
        setSelectedRegionId(null);
      }
      
      // Apply final filtering by price for same publication + duration
      const uniqueSchemes = finalSchemes.reduce((acc, current) => {
        const existing = acc.find(scheme => 
          scheme.duration === current.duration &&
          scheme.publications === current.publications
        );
        
        if (existing) {
          // Keep the scheme with lower price
          if (current.price < existing.price) {
            const index = acc.indexOf(existing);
            acc[index] = current;
          }
        } else {
          acc.push(current);
        }
        
        return acc;
      }, []);

    // Sort the final schemes by publication order
    const sortedSchemes = sortSchemesByPublication(uniqueSchemes);
    
    let selectedPublicationVal = sortedSchemes.find(
      item => item.code === publicationCheckedStatus
    ) || sortedSchemes[0];

    const selectedGiftVal = selectedPublicationVal?.gifts || [];
    const publicationImage = publicationImg[selectedPublicationVal?.sap_publication];
    const yearPlanData = selectedPublicationVal?.duration || 1;
   
    setPublicationCheckedStatus(null);
    setShowGiftSelectionModal(false);
    setShowPublicationImage(null);
    setSelectedCityIndex(index);
    setShowPincodeServiceAbleIssue(false);
    setPincodeValueErrorMsg(false);
    setCityPublicationScheme(sortedSchemes);
    setAllGifts([]);

    // Session storage updates...
    sessionStorage.setItem("stg_scheme_id", selectedPublicationVal?.id);
    sessionStorage.setItem("stg_location_code", city?.id);
    sessionStorage.setItem("stg_city", city?.name);
    sessionStorage.setItem("stg_salesOrg", selectedPublicationVal?.code);
    sessionStorage.setItem("stg_selectedPlan_Name", selectedPublicationVal?.publications);
    sessionStorage.setItem("moe_acq_selected_yearPlan", yearPlanData);
    sessionStorage.setItem("stg_selectedPlan_Duration", yearPlanData);
    sessionStorage.setItem("moe_acq_selected_planPrice", selectedPublicationVal?.price);
    sessionStorage.setItem("moe_acq_selected_coverPrice", selectedPublicationVal?.cover_price);

    // Store the NEW selected region in session storage
    if (targetRegion) {
      sessionStorage.setItem("stg_selectedRegion", targetRegion.id);
    } else {
      sessionStorage.removeItem("stg_selectedRegion");
    }

    // UI state updates...
    if (city?.pincode_required) {
      setShowPincodeBar(false);
      setShowProeedBtn(true);
      setPincodeValue("");
    } else {
      setShowProeedBtn(true);
      setShowPincodeBar(false);
    }
  }
}, [cityList, publicationCheckedStatus]); // Remove selectedRegionId from dependencies

  // Publication change handler
  const publicationChange = useCallback((e) => {
    const selectscheme = e.target.dataset.code;
    const cityindex = selectedCityIndex;
    const city = cityList[cityindex];
    
    // Get city publication schemes
    const cityPublicationObj = filterSchemes(
      Object.values(city.publication_wise_schemes).reverse()
    );
    
    // Get regional schemes from selected region if available
    let mergedSchemes = [...cityPublicationObj];
    
    if (selectedRegionId && city?.regions?.length > 0) {
      const selectedRegion = city.regions.find(region => region.id === selectedRegionId);
      
      if (selectedRegion && selectedRegion.regional_publication_wise_schemes) {
        const regionalSchemes = filterSchemes(
          Object.values(selectedRegion.regional_publication_wise_schemes).reverse()
        );
        mergedSchemes = [...mergedSchemes, ...regionalSchemes];
      }
    }
    
    // Remove duplicates based on scheme code and keep the one with lower price
    const uniqueSchemes = mergedSchemes.reduce((acc, current) => {
      const existing = acc.find(scheme => 
        scheme.code === current.code && 
        scheme.duration === current.duration &&
        scheme.publications === current.publications
      );
      
      if (existing) {
        // Keep the scheme with lower price
        if (current.price < existing.price) {
          const index = acc.indexOf(existing);
          acc[index] = current;
        }
      } else {
        acc.push(current);
      }
      
      return acc;
    }, []);
    
    // Find the selected scheme from merged schemes
    let selectedPublicationVal = uniqueSchemes.find(
      item => item.code === selectscheme
    ) || uniqueSchemes[0];

    const selectedGiftVal = selectedPublicationVal?.gifts || [];
    const publicationImage = publicationImg[selectedPublicationVal?.sap_publication];
    const yearPlanData = selectedPublicationVal.duration || 1;
    
    setPublicationCheckedStatus(selectscheme);
    setShowGiftSelectionModal(selectedGiftVal.length > 0);
    setShowPublicationImage(publicationImage);
    setAllGifts(selectedGiftVal);
    setSelectedGiftOne(selectedGiftVal[0] || null);

    // Session storage updates
    sessionStorage.setItem("stg_scheme_id", selectedPublicationVal.id);
    sessionStorage.setItem("stg_salesOrg", selectedPublicationVal.code);
    sessionStorage.setItem("stg_selectedPlan_Name", selectedPublicationVal.publications);
    sessionStorage.setItem("moe_acq_selected_yearPlan", yearPlanData);
    sessionStorage.setItem("stg_selectedPlan_Duration", yearPlanData);
    sessionStorage.setItem("moe_acq_selected_planPrice", selectedPublicationVal.price);
    sessionStorage.setItem("moe_acq_selected_coverPrice", selectedPublicationVal.cover_price);
    
    // Store selected region in session storage if available
    if (selectedRegionId) {
      sessionStorage.setItem("stg_selectedRegion", selectedRegionId);
    }
    
    // GTM event
    const schemeData = {
      eventName: 'scheme_selected',
      scheme_code: e.target.getAttribute("data-code"),
      scheme_duration: e.target.getAttribute("data-duration"),
      scheme_price: e.target.getAttribute("data-price"),
      scheme_name: e.target.getAttribute("data-name"),
      scheme_value: e.target.value,
      scheme_booking_type: forInstitutional ? 'CORPORATE' : 'REGULAR',
      selected_region: selectedRegionId || 'none'
    }
    GTM_data_push(schemeData);
  }, [cityList, selectedCityIndex, selectedRegionId, forInstitutional]);

  // Show login handler
  const showLogin = useCallback(async (gift = null) => {
      const fallbackGift = gift || selectedGiftOne;

      // Validate pincode if required
      // if (showPincodeBar && (!pincodeValue || pincodeValue.length !== 6)) {
      //   setPincodeValueErrorMsg(true);
      //   setShowGiftSelectionModal(false);
      //   errorMsg("Please enter a valid 6-digit pincode!");
      //   return;
      // }

      // Validate publication
      if (!publicationCheckedStatus) {
        setShowGiftSelectionModal(false);
        errorMsg("Please select a publication plan.");
        return;
      }

      // Validate pincode via API if needed
      if (showPincodeBar && pincodeValue) {
        try {
          const response = await UserService.verifyAcqFreshPinCodeEligibility(
            pincodeValue,
            sessionStorage.getItem("stg_scheme_id"),
            "acquisition_journey",
            forInstitutional
          );

          if (!response.data.body.isEligible) {
            setShowPincodeServiceAbleIssue(true);
            setShowGiftSelectionModal(false);
            errorMsg("Sorry! This pincode is not serviceable.");
            sessionStorage.setItem("moe_acq_Pincode", "Invalid Pincode");
            return;
          }

          // Success: Save pincode
          sessionStorage.setItem("moe_acq_Pincode", pincodeValue);
          sessionStorage.setItem("stg_city", response.data.body.city);
        } catch (err) {
          setShowGiftSelectionModal(false);
          errorMsg("Sorry! Invalid pincode.");
          sessionStorage.setItem("moe_acq_Pincode", "Invalid Pincode");
          return;
        }
      } else {
        sessionStorage.setItem("moe_acq_Pincode", "Not Required");
      }

      // If all valid: prepare order
      const newOrderData = {
        planId: sessionStorage.getItem("stg_scheme_id"),
        planName: sessionStorage.getItem("stg_selectedPlan_Name"),
        planPrice: sessionStorage.getItem("moe_acq_selected_planPrice"),
        coverPrice: sessionStorage.getItem("moe_acq_selected_coverPrice"),
        planDuration: sessionStorage.getItem("moe_acq_selected_yearPlan"),
        cityName: sessionStorage.getItem("stg_city"),
        cityPincode: parseInt(pincodeValue) ? pincodeValue : "",
        gift: fallbackGift
      };

      setOrderData(newOrderData);
      sessionStorage.setItem("stg_selectedGift_Name", fallbackGift?.name || null);
      setShowGiftSelectionModal(false);
      setShowAcquisitionModel(false);
      setShowLoginModel(true);
  }, [
    pincodeValue, 
    showPincodeBar, 
    selectedGiftOne, 
    forInstitutional, 
    errorMsg, 
    publicationCheckedStatus
  ]);


  // Initialize component
  useEffect(() => {
    ReactGA.ga('send','pageview','/newCustomer');
    AuthService.getAuth("htprint", "htprint");
    
    if (sessionStorage.getItem("redirect_loginPage") !== "true") {
      window.Moengage.destroy_session();
    }
    
    // Check corporate status
    const queryParams = new URLSearchParams(window.location.search);
    const flagValue = queryParams.get('utm_source')?.trim().toUpperCase();
    const isCorporate = flagValue === 'CORPORATE' && CORPORATE_STATUS;
    
    if (isCorporate && 
        !sessionStorage.getItem("stg_otpEmailValidated") && 
        !sessionStorage.getItem("stg_verifiedEmail")) {
      sessionStorage.removeItem("stg_otpEmailValidated");
      sessionStorage.removeItem("stg_verifiedEmail");
      window.location = "/";
    }
    
    setForInstitutional(isCorporate);
    
    // Reset session storage
    sessionStorage.removeItem("stg_scheme_id");
    sessionStorage.removeItem("selectedSchemes");
    sessionStorage.removeItem("stg_acq_exitingUser");
    sessionStorage.removeItem("stg_acq_freshUser");
    sessionStorage.removeItem("orderDetails");
    sessionStorage.removeItem("stg_isWhatsappChecked");
    sessionStorage.removeItem("stg_location_code");
    sessionStorage.removeItem("lead_id");
    sessionStorage.setItem("createNewAccountActive", "ON");
    sessionStorage.setItem("stg_acq_userType", "New User");
    sessionStorage.setItem("stg_userJourneyType", "Acquisition");
    
    // Fetch subscription details
    UserService.acqSubscriptionDetails(isCorporate)
      .then(response => {
        if (response.data) {
          const sortedCities = [...response.data.cities].sort(sortCitybyOrder);
          setCityList(sortedCities);
          setPageLoader(false);
          
          // Set default Delhi city
          const delhiIndex = sortedCities.findIndex(item => item.code === 'DELK');
          const delhiCity = sortedCities[delhiIndex];
          
          if (delhiCity) {
            const cityPublicationObj = filterSchemes(
              Object.values(delhiCity.publication_wise_schemes).reverse()
            );
            
            // 🔹 Get regional schemes and apply deduplication logic
            let finalSchemes = [...cityPublicationObj];
            
            const regionList = delhiCity?.regions || [];
            if (regionList.length > 0) {
              setRegionList(regionList);
              setShowRegions(true);
              
              // Find region with most data instead of first region
              const regionWithMostData = findRegionWithMostData(regionList);
              setSelectedRegionId(regionWithMostData?.id || null);
              
              // 🔹 Apply deduplication logic - same as cityChange function
              if (regionWithMostData && regionWithMostData.regional_publication_wise_schemes) {
                const regionalSchemes = filterSchemes(
                  Object.values(regionWithMostData.regional_publication_wise_schemes).reverse()
                );
                
                // Get regional scheme keys for current region only
                const regionalSchemeKeys = regionalSchemes.map(scheme => 
                  `${scheme.publications}_${scheme.duration}`
                );
                
                // 🔹 Filter out sales org schemes that exist in current region
                const filteredSalesOrgSchemes = cityPublicationObj.filter(scheme => 
                  !regionalSchemeKeys.includes(`${scheme.publications}_${scheme.duration}`)
                );
                
                // 🔹 Combine filtered sales org schemes with regional schemes
                finalSchemes = [...filteredSalesOrgSchemes, ...regionalSchemes];
              }
            } else { 
              setShowRegions(false);
            }
            
            // 🔹 Apply final filtering by price for same publication + duration
            const uniqueSchemes = finalSchemes.reduce((acc, current) => {
              const existing = acc.find(scheme => 
                scheme.duration === current.duration &&
                scheme.publications === current.publications
              );
              
              if (existing) {
                // Keep the scheme with lower price
                if (current.price < existing.price) {
                  const index = acc.indexOf(existing);
                  acc[index] = current;
                }
              } else {
                acc.push(current);
              }
              
              return acc;
            }, []);
            
            // Sort the final schemes by publication order
            const sortedSchemes = sortSchemesByPublication(uniqueSchemes);
            
            const selectedPublicationVal = sortedSchemes[0];
            const selectedGiftVal = selectedPublicationVal?.gifts || [];
            const publicationImage = publicationImg[selectedPublicationVal.publications];

            setSelectedCityIndex(delhiIndex);
            setCityPublicationScheme(sortedSchemes); // Use sorted schemes
            setPublicationCheckedStatus(null);
            setShowGiftSelectionModal(false);
            setShowPublicationImage(publicationImage);
            setAllGifts(selectedGiftVal);
            
            // Session storage updates
            sessionStorage.setItem("stg_scheme_id", selectedPublicationVal.id);
            sessionStorage.setItem("stg_location_code", delhiCity.id);
            sessionStorage.setItem("stg_city", delhiCity.name);
            sessionStorage.setItem("stg_salesOrg", selectedPublicationVal.code);
            sessionStorage.setItem("stg_selectedPlan_Name", selectedPublicationVal.publications);
            sessionStorage.setItem("moe_acq_selected_yearPlan", selectedPublicationVal.duration || 1);
            sessionStorage.setItem("stg_selectedPlan_Duration", selectedPublicationVal.duration || 1);
            sessionStorage.setItem("moe_acq_selected_planPrice", selectedPublicationVal.price);
            sessionStorage.setItem("moe_acq_selected_coverPrice", selectedPublicationVal.cover_price);
            
            // Store selected region in session storage
            if (regionList.length > 0) {
              const regionWithMostData = findRegionWithMostData(regionList);
              sessionStorage.setItem("stg_selectedRegion", regionWithMostData?.id || regionList[0].id);
            }
          }
        }
      })
      .catch(err => console.error(err));
  }, []);

  // Focus pincode input on error
  useEffect(() => {
    if ((showPincodeServiceAbleIssue || pincodeValueErrorMsg) && pincodeInputRef.current) {
      pincodeInputRef.current.focus();
    }
  }, [showPincodeServiceAbleIssue, pincodeValueErrorMsg]);

  // No schemes found component
  // No schemes found component
const NoSchemesFound = () => (
  <div className="no-schemes-wrapper">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12">
          <div className="no-schemes-card">
            {/* Header Section */}
            <div className="no-schemes-header">
              <div className="no-schemes-icon">
                <FontAwesomeIcon icon={faGift} size="3x" />
              </div>
              <h3 className="no-schemes-title">No Schemes Available</h3>
              <p className="no-schemes-subtitle">
                Sorry, no subscription schemes are currently available for this region.
                Please try selecting a different region or city.
              </p>
            </div>

            {/* Contact Section */}
            <div className="contact-support-section">
              <div className="contact-header">
                <h4 className="contact-main-title">CONTACT OUR TEAM</h4>
              </div>
              
              <p className="contact-timing">
                For any assistance, please reach out to us at: 
                <strong> (9AM to 6PM - Mon to Sat)</strong>
              </p>

              {/* Contact Cards Grid */}
              <div className="contact-grid">
                {/* Delhi Contact */}
                <div className="contact-card">
                  <div className="contact-location-header">
                    <h5 className="location-name">DELHI</h5>
                    <div className="location-divider"></div>
                  </div>
                  <div className="contact-details">
                    <div className="contact-item">
                      <img src={mailIcon} alt="Email" className="contact-icon" />
                      <a href="mailto:customerservice@hindustantimes.com" className="contact-link">
                        customerservice@hindustantimes.com
                      </a>
                    </div>
                    <div className="contact-item">
                      <img src={telephoneIcon} alt="Phone" className="contact-icon" />
                      <a href="tel:01160004242" className="contact-link">
                        011-60004242
                      </a>
                    </div>
                  </div>
                </div>

                {/* Mumbai Contact */}
                <div className="contact-card">
                  <div className="contact-location-header">
                    <h5 className="location-name">MUMBAI</h5>
                    <div className="location-divider"></div>
                  </div>
                  <div className="contact-details">
                    <div className="contact-item">
                      <img src={mailIcon} alt="Email" className="contact-icon" />
                      <a href="mailto:subscription@hindustantimes.com" className="contact-link">
                        subscription@hindustantimes.com
                      </a>
                    </div>
                    <div className="contact-item">
                      <img src={telephoneIcon} alt="Phone" className="contact-icon" />
                      <a href="tel:02267764242" className="contact-link">
                        022-67764242
                      </a>
                    </div>
                  </div>
                </div>

                {/* Punjab Contact */}
                <div className="contact-card">
                  <div className="contact-location-header">
                    <h5 className="location-name">PUNJAB</h5>
                    <div className="location-divider"></div>
                  </div>
                  <div className="contact-details">
                    <div className="contact-item">
                      <img src={mailIcon} alt="Email" className="contact-icon" />
                      <a href="mailto:circulationcustomercare@hindustantimes.com" className="contact-link">
                        circulationcustomercare@hindustantimes.com
                      </a>
                    </div>
                    <div className="contact-item">
                      <img src={telephoneIcon} alt="Phone" className="contact-icon" />
                      <a href="tel:+917009989177" className="contact-link">
                        +91 7009989177
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
  // Render publication blocks
  const renderCityPublicationBlocks = useCallback(() => {

    return cityPublicationScheme.map((scheme, key) => {
      const durationInMonths = scheme.duration;
      const monthDisplay = durationInMonths > 1 
        ? `${durationInMonths} months` 
        : durationInMonths === 1 
          ? "month" 
          : "";
      
      const saveAmtPer = Math.floor(100 - (scheme.price / scheme.cover_price) * 100);
      const isChecked = scheme.code === publicationCheckedStatus;
      const hasGifts = scheme.gifts && scheme.gifts.length > 0;

      return (
        <div className="ht_publication_tab" key={key}>
          <input
            type="radio"
            name="tabs"
            className="scheme_select"
            data-code={scheme.code}
            data-name={scheme.name}
            data-price={scheme.price}
            data-duration={scheme.duration}
            value={scheme.publications}
            id={`${key}`}
            onChange={publicationChange}
            onClick={publicationChange}
            checked={isChecked}
          />
          <label htmlFor={`${key}`}>
            <div className="priceDetails">
              <div className="pricing-label_img">
                <img
                  className={forInstitutional && 
                    (scheme.publications === "Mint;LM" || 
                     scheme.publications === "LM;Mint")
                    ? "img-fluid max-wid-70"
                    : "img-fluid"}
                  src={publicationImg[scheme.publications]}
                  alt={scheme.publications}
                />
              </div>
              <div className="pricing-label-details">
                {scheme.cover_price > 0 && (
                  <span className="saveLabel_discount" id="discPrice">
                    <span>Save</span>
                    <span className="percent">{saveAmtPer} % </span>
                    <span>Off</span>
                  </span>
                )}
                <div className={`pricing-table purple ${scheme.cover_price > 0 ? "withDiscount" : ""}`}>
                  <div className="pricing-features">
                    <div className="feature">₹{scheme.price}</div>
                  </div>
                  <div className="price-tag">
                    {scheme.cover_price > 0 ? (
                      <div className="stike">
                        <span className="font-weight-bold">
                          ₹{scheme.cover_price}
                        </span>
                        <span>{monthDisplay ? `/${monthDisplay}` : ''}</span>
                      </div>
                    ) : (
                      <span>{monthDisplay ? `/${monthDisplay}` : ''}</span>
                    )}
                  </div>
                </div>
              </div>
              {forInstitutional && (
                <div className="corporate-btn">
                  <span>{planNames[scheme.publications]}</span>
                </div>
              )}
            </div>
            <div className="pub-gift-box">
              <div className="giftMain">
                <img 
                  src={hasGifts ? giftIcon : bellIcon} 
                  className="img-fluid2" 
                  alt={hasGifts ? "Gift" : "Bell"} 
                />
              </div>
              <span className="giftText">
                <strong>{hasGifts ? "Congratulations!" : "Subscribe!"}</strong>
                <br />
                {hasGifts 
                  ? "You are eligible for a free gift with this offer."
                  : `Get ${scheme.duration} months of uninterrupted news delivery for just ₹${scheme.price}`}
              </span>
            </div>
          </label>
        </div>
      );
    });
  }, [cityPublicationScheme, publicationCheckedStatus, forInstitutional, publicationChange]);

  // Render city list
  const renderCityList = useCallback((type = "less") => {
    const cities = type === "less" 
      ? cityList.slice(0, 8) 
      : cityList.slice(8);
    
    return cities.map((option, index) => {
      const cityName = option.name.toLowerCase();
      const imgSrc = cityImagesArr[cityName] || cityDefaultSvg;
      
      return (
        <div className="ht_tab" key={index}>
          <input
            type="radio"
            name="cities"
            value={index}
            id={option.name}
            onClick={cityChange}
            defaultChecked={
              (type === "less" && cityName === "delhi") ||
              (type === "more" && index === 0)
            }
          />
          <label className="circle_style mt-3" htmlFor={option.name}>
            <div className="city-img">
              <img 
                className="img-fluid" 
                src={imgSrc} 
                width={55} 
                height={53} 
                alt={option.name} 
              />
            </div>
            <div className="fnt-style">
              <strong>{registrationGetCityName(option.name)}</strong>
            </div>
          </label>
        </div>
      );
    });
  }, [cityList, cityChange]);

  // Region change handler
  const regionChange = useCallback((e) => {
    const regionId = e.target.value;
    setSelectedRegionId(regionId);
    
    if (selectedCityIndex !== -1 && regionId) {
      const city = cityList[selectedCityIndex];
      
      // Get city publication schemes (sales org level)
      const cityPublicationObj = filterSchemes(
        Object.values(city.publication_wise_schemes).reverse()
      );
      
      let finalSchemes = [...cityPublicationObj];
      
      // Get regional schemes from selected region
      const selectedRegion = city.regions.find(region => region.id === regionId);
      
      if (selectedRegion && selectedRegion.regional_publication_wise_schemes) {
        const regionalSchemes = filterSchemes(
          Object.values(selectedRegion.regional_publication_wise_schemes).reverse()
        );
        
        // Get regional scheme keys for current selected region only
        const regionalSchemeKeys = regionalSchemes.map(scheme => 
          `${scheme.publications}_${scheme.duration}`
        );
        
        // Filter out sales org schemes that exist in current selected region
        const filteredSalesOrgSchemes = cityPublicationObj.filter(scheme => 
          !regionalSchemeKeys.includes(`${scheme.publications}_${scheme.duration}`)
        );
        
        // Combine filtered sales org schemes with regional schemes
        finalSchemes = [...filteredSalesOrgSchemes, ...regionalSchemes];
      }
      
      // Apply final filtering by price for same publication + duration
      const uniqueSchemes = finalSchemes.reduce((acc, current) => {
        const existing = acc.find(scheme => 
          scheme.duration === current.duration &&
          scheme.publications === current.publications
        );
        
        if (existing) {
          // Keep the scheme with lower price
          if (current.price < existing.price) {
            const index = acc.indexOf(existing);
            acc[index] = current;
          }
        } else {
          acc.push(current);
        }
        
        return acc;
      }, []);
    
    // Sort the final schemes by publication order
    const sortedSchemes = sortSchemesByPublication(uniqueSchemes);
    
    // Update schemes with new region selection
    setCityPublicationScheme(sortedSchemes);
    
    // Update selected publication if current one exists in new scheme list
    let selectedPublicationVal = sortedSchemes.find(
      item => item.code === publicationCheckedStatus
    ) || sortedSchemes[0];
    
    // Update session storage and UI states
    if (selectedPublicationVal) {
      const selectedGiftVal = selectedPublicationVal?.gifts || [];
      const publicationImage = publicationImg[selectedPublicationVal?.sap_publication];
      const yearPlanData = selectedPublicationVal.duration || 1;
      
      setAllGifts([]);
      setShowPublicationImage(publicationImage);
      setShowProeedBtn(true);
      
      sessionStorage.setItem("stg_scheme_id", selectedPublicationVal.id);
      sessionStorage.setItem("stg_selectedRegion", regionId);
      sessionStorage.setItem("stg_salesOrg", selectedPublicationVal.code);
      sessionStorage.setItem("stg_selectedPlan_Name", selectedPublicationVal.publications);
      sessionStorage.setItem("moe_acq_selected_yearPlan", yearPlanData);
      sessionStorage.setItem("stg_selectedPlan_Duration", yearPlanData);
      sessionStorage.setItem("moe_acq_selected_planPrice", selectedPublicationVal.price);
      sessionStorage.setItem("moe_acq_selected_coverPrice", selectedPublicationVal.cover_price);
      }
    };
  }, [selectedCityIndex, cityList, publicationCheckedStatus]);

  // Render Region list - Updated to make entire area clickable
  const renderRegionList = useCallback(() => {
    return (
      <div className="region-selection-container">
        {regionList.map((region, index) => {
          // Count schemes for this region (optional - for debugging)
          const schemeCount = region.regional_publication_wise_schemes 
            ? Object.values(region.regional_publication_wise_schemes).flat().length 
            : 0;
          
          return (
            <label 
              key={region.id} 
              className={`region-option ${region.id === selectedRegionId ? 'selected' : ''}`}
              htmlFor={`region_${region.id}`}
              title={`${schemeCount} schemes available`} // Optional tooltip
            >
              <input
                type="radio"
                name="regions"
                value={region.id}
                id={`region_${region.id}`}
                onChange={regionChange}
                checked={region.id === selectedRegionId}
              />
              <span className="region-text">
                {region.alias ? region.alias : (region.name ? region.name : '')}
                {/* Optional: Show scheme count */}
                {/* <small className="scheme-count"> ({schemeCount})</small> */}
              </span>
            </label>
          );
        })}
      </div>
    );
  }, [regionList, regionChange, selectedRegionId]);

  // Close gift modal
  const closeGiftSelectionModal = useCallback(() => {
    setShowGiftSelectionModal(false);
  }, []);

  return (
    <div className="main-first">
      <div className="side-img">
        {showAcquisitionHeader && (
          <>
            <LoginSidebar forInstitutional={forInstitutional} />
            {pageLoader && <PageLoader />}
          </>
        )}

        {showAcquisitionModel && (
          <div className="col-md-8 div-right">
            <div className="ht_page">
              {(seeLessCityView || seeMoreCityView) && (
                <div className="col-md-12 p-0">
                  <div className="back-btn-pincode">
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      size="2x"
                      className="faArrowLeft"
                      onClick={redirectToHome}
                    />
                    <h6 className="mb-2 fnt-style-city1">Select Your City</h6>
                  </div>
                  
                  {seeLessCityView && (
                    <div className="ht_city_selct allTabs">
                      {renderCityList("less")}
                    </div>
                  )}

                  {seeMoreCityView && (
                    <div className="ht_city_selct allTabs">
                      {renderCityList("more")}
                    </div>
                  )}
                </div>
              )}

              {showPincodeBar && (
                <div className="form-group blackClourV2 mt-3" id="pincodBox">
                  <input
                    ref={pincodeInputRef}
                    className="form-control cus_sel_dropBox"
                    placeholder="Please Enter The Pincode"
                    value={pincodeValue}
                    type="text"
                    maxLength="6"
                    id="pincodBoxInput"
                    onChange={handleInputValue}
                  />
                </div>
              )}

              {showRegions && regionList.length > 0 && (
                <div className="form-group blackClourV2 mt-3" id="regionBox">
                  <h6 className="fnt-style-city1">Select Your Region</h6>
                  {renderRegionList()}
                </div>
              )}

              {cityList.length > 8 && seeLessCityView && (
                <div className="title_more mt-3">
                  <i className="fa fa-angle-down"></i>
                  <span onClick={() => {
                    setSeeMoreCityView(true);
                    setSeeLessCityView(false);
                  }}>See More Cities</span>
                </div>
              )}

              {cityList.length > 8 && seeMoreCityView && (
                <div className="title_more mt-3">
                  <i className="fa fa-angle-up"></i>
                  <span onClick={() => {
                    setSeeMoreCityView(false);
                    setSeeLessCityView(true);
                  }}>See Less Cities</span>
                </div>
              )}

              <PopupContactus
                showModalPopup={showPopupAlertState}
                onPopupClose={() => setShowPopupAlertState(false)}
              />
            </div>

            
            {cityPublicationScheme?.length === 0 && !pageLoader ? (
              <NoSchemesFound />
            ) : (
              <>
                <div className="ht_publication_selct">
                  {renderCityPublicationBlocks()}
                </div>

                {(showProeedBtn || pincodeValue.length > 5) && (
                  <div className="whatsapp-main">
                    <input
                      type="checkbox"
                      id="Whatsapp"
                      name="WhatsappSelection"
                      value="Whatsapp"
                      checked={isCheckedWhatsappBox}
                      onChange={handleWhatsappChange}
                    />
                    <label className="ml-2 whtsapp_style" htmlFor="Whatsapp">
                      I accept to get the notifications through WhatsApp
                    </label>
                  </div>
                )}

                <div className="cityFl_button mx-auto mt-1">
                  <button
                    className="btn proceedBtn"
                    onClick={() => showLogin()}
                    disabled={!(showProeedBtn || pincodeValue.length > 5)}
                  >
                    Proceed
                  </button>
                </div>
              </>
            )}
            
          </div>
        )}

        {showLoginModel && (
          <div className="col-md-8 div-right">
            <Order orderData={orderData} />
          </div>
        )}

        {showCheckoutModel && <AllSchemes />}

        {showGiftSelectionModal && (
          <GiftSelectionModal 
            showModalPopup={showGiftSelectionModal}
            onPopupClose={closeGiftSelectionModal}
            errorMsg={errorMsg}
            isCheckedWhatsappBox={isCheckedWhatsappBox}
            handleWhatsappChange={handleWhatsappChange}
            proceed={showLogin}
            selectedGiftOne={selectedGiftOne}
            setSelectedGiftOne={setSelectedGiftOne}
            showAllGifts={allGifts}
            publicationImage={showPublicationImage}
          />
        )}
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
};

export default AcqHomepage;